// extracted by mini-css-extract-plugin
export default {"modalConfirmBackdrop":"WUxedBuoHekL8U0Io0Zm","modalConfirm":"AdpYLj1HQNvHAH6LGizj","modalFooter":"EFNWTLXpoY7hwNNZBaZY"};